import * as Sentry from "@sentry/react";
import { createFileRoute, Outlet } from "@tanstack/react-router";

import { authenticate } from "@/api/api";
import { bannersPlacementQueryOptions } from "@/hooks/useBannersPlacement";
import { CommonTrackingEvents, rudderAnalytics } from "@/lib/rudderstack";
import { BannersPlacementSlug } from "@/types/enums";
import { decode } from "@/utils/tokens";

export const Route = createFileRoute("/_authenticated")({
  component: RouteComponent,
  beforeLoad: async () => {
    const accessToken = await authenticate();

    const { userId } = decode(accessToken);
    Sentry.setUser({ id: userId });
    rudderAnalytics.identify(userId);
  },
  loader: ({ context }) => {
    // Prefetch banner placements in background without blocking navigation
    // In future, if there are a lot more slugs to fetch, we can consider fetching multiple slugs in a single request if needed
    Object.values(BannersPlacementSlug).forEach((slug) => {
      context.queryClient.prefetchQuery(bannersPlacementQueryOptions(slug));
    });
  },
  onEnter: () => {
    rudderAnalytics.track(CommonTrackingEvents.USER_OPENED_APP, (data) => {
      console.log("Tracking USER_OPENED_APP event:", data);
    });
  },
});

function RouteComponent() {
  return <Outlet />;
}
